import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img from '../assets/others/11102053.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { Helmet } from 'react-helmet-async'
library.add(fas, fab)

const MapStyle = {
  width: "100%",
  height: 200
};

const Contact = () => {
  return (
    <div>
      <Helmet>
      <title>Contact Takshila VLSI – Bangalore & Hyderabad | Takshila VLSI</title>
      <meta name="description" content="Contact Bangalore and Hyderabad centers for VLSI course details, fees, admissions, and batch schedules. Call or WhatsApp today to get started with Takshila VLSI." />
      <link rel="canonical" href="https://www.takshila-vlsi.com/contact-us/" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Contact Takshila VLSI – Bangalore & Hyderabad | Takshila VLSI" />
      <meta property="og:description" content="Contact Bangalore and Hyderabad centers for VLSI course details, fees, admissions, and batch schedules. Call or WhatsApp today to get started with Takshila VLSI." />
      <meta property="og:url" content="https://www.takshila-vlsi.com/contact-us/" />
      <meta property="og:site_name" content="Takshila VLSI" />
      <meta property="article:modified_time" content="2024-07-10T16:05:45+00:00" />
      <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Header/>
      <main>
      <section className='section-banner pg-banner mb-lg-5 p-lg-5 p-3 pt-4'>
            <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md">
                                <div class="pg-title-sec p-4 p-lg-5 bg-3 dark-bg">
                                    <h1 className='pg-title pb-3'>Feel free to get in touch</h1>
                                    <p className='pg-title-desc'>Welcome to Takshila Institute of VLSI Technologies where we equip you for the VLSI Industry. We do like to hear from you. Contact us to discuss about your career and how our VLSI courses will help you champion a new path in the VLSI Industry.
                                    </p>
                                </div>
                              </div>
                          </div>
            </div>
          </section>
          <section className='connect-section ws-section pb-5'>
                <div className='container'>
                <div class="row">
                  <div class="col-lg text-center">
                    <h2 class="ws-section_heading pd-20">Don't hesitate to contact us</h2>
                  </div>
                </div>
                
                <div class="row">
                        <div class="col-lg">
                          <div className='ctn-frm'>
                        <h2 class="mb-3">Lest Connect</h2>
                        <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="850"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                    frameborder="0" 
                                    title='Register Now'
                                   
                                />
                        </div>
                        </div>
                        <div class="col-lg img-radius">
                        <img src={img} alt=''/>
                        </div>
                    </div>
                    </div>
          </section>
          <section className='ws-section pb-5'>
              <div class="container">
                <div class="row justify-content-between g-3">
                  <div class="col-lg-5">
                    <div className='ctn-bx bg-drk-3 dark-bg'>
                      <div className='txt-2 mb-4'>Contact Info: Bengaluru</div>
                        <div className='d-flex'>
                        <div class="ctn-bx-icon txt-2"><FontAwesomeIcon icon="fa-solid fa-location-dot" /></div>
                        <div class="ctn-bx-text ps-3">
                          <div class="text-xs heading-font text-start">Address</div>
                          <p>Ram Arcade, 90/1B, CKB Layout, Chandra Layout, Marathahalli, Opp Innovative Multiplex, Bengaluru, Karnataka 560037, INDIA</p>
                          </div>
                        </div>

                        <div className='d-flex'>
                        <div class="ctn-bx-icon txt-2"><FontAwesomeIcon icon="fa-solid fa-phone" /></div>
                        <div class="ctn-bx-text ps-3">
                          <div class="text-xs heading-font text-start">Call Us</div>
                          <p>+91-97429 72744</p>
                          </div>
                        </div>

                        <div className='d-flex'>
                        <div class="ctn-bx-icon txt-2"><FontAwesomeIcon icon="fa-solid fa-envelope" /></div>
                        <div class="ctn-bx-text ps-3">
                          <div class="text-xs heading-font text-start">Mail Us</div>
                          <p>info@takshila-vlsi.com</p>
                          </div>
                        </div>
                        <div className='mt-4'>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.8893340240206!2d77.69324791378995!3d12.978929418231576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae11422976b559%3A0x8c2a8e7b271c31db!2sTakshila+Institute+of+VLSI+Technologies!5e0!3m2!1sen!2sin!4v1545760477071"
                            width={MapStyle.width}
                            height={MapStyle.height}
                            frameBorder="0"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            aria-hidden="false"
                            tabIndex="0"
                            title="Humanity First Indonesia"
                          />
                        </div>
                      
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div className='ctn-bx bg-drk-3 dark-bg'>
                      <div className='txt-2 mb-4'>Contact Info: Hyderabd</div>
                        <div className='d-flex'>
                        <div class="ctn-bx-icon txt-2"><FontAwesomeIcon icon="fa-solid fa-location-dot" /></div>
                        <div class="ctn-bx-text ps-3">
                          <div class="text-xs heading-font text-start">Address</div>
                          <p>KSR Towers, 2nd Floor, Hitech City Road, Phase 2, Kavuri Hills, Madhapur, Hyderabad, Telangana 500081, INDIA</p>
                          </div>
                        </div>

                        <div className='d-flex'>
                        <div class="ctn-bx-icon txt-2"><FontAwesomeIcon icon="fa-solid fa-phone" /></div>
                        <div class="ctn-bx-text ps-3">
                          <div class="text-xs heading-font text-start">Call Us</div>
                          <p>+91-97429 72744</p>
                          </div>
                        </div>

                        <div className='d-flex'>
                        <div class="ctn-bx-icon txt-2"><FontAwesomeIcon icon="fa-solid fa-envelope" /></div>
                        <div class="ctn-bx-text ps-3">
                          <div class="text-xs heading-font text-start">Mail Us</div>
                          <p>info@takshila-vlsi.com</p>
                          </div>
                        </div>
                        <div className='mt-4'>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4659.223718966279!2d78.38890010766882!3d17.44109337670676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb910a0ba95dd5%3A0x488e8e195af39f69!2sTakshila%20VLSI%20Institute%20Hyderabad!5e0!3m2!1sen!2sin!4v1720624227278!5m2!1sen!2sin"
                            width={MapStyle.width}
                            height={MapStyle.height}
                            frameBorder="0"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            aria-hidden="false"
                            tabIndex="0"
                            title="Humanity First Indonesia"
                          />
                        </div>
                      
                    </div>
                  </div>
                </div>
              </div>
          </section>
      </main>
      <Enrollaction/>
      <Partnersec/> 
      <Footer/>
    </div>
  )
}

export default Contact